import React, { useState } from 'react';

const Settings = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [formData, setFormData] = useState({
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
  });

  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleProfileSubmit = (e) => {
    e.preventDefault();
    // Here you would typically make an API call to update the user's profile
    setIsEditing(false);
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      alert('New passwords do not match!');
      return;
    }
    // Here you would typically make an API call to update the password
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    });
    setShowPasswordForm(false);
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-primary">Settings</h1>
        <p className="text-neutral">Manage your account settings and preferences</p>
      </div>

      {/* Profile Information */}
      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-primary">Profile Information</h2>
          <button
            onClick={() => setIsEditing(!isEditing)}
            className="text-primary hover:text-primary-dark"
          >
            <i className={`fas ${isEditing ? 'fa-times' : 'fa-edit'}`}></i>
          </button>
        </div>

        <form onSubmit={handleProfileSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium text-neutral mb-1">
                First Name
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                readOnly={!isEditing}
                className={`w-full p-2 border rounded-lg ${
                  isEditing 
                    ? 'border-primary focus:ring-2 focus:ring-primary focus:border-transparent' 
                    : 'border-light bg-gray-50'
                }`}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-neutral mb-1">
                Last Name
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                readOnly={!isEditing}
                className={`w-full p-2 border rounded-lg ${
                  isEditing 
                    ? 'border-primary focus:ring-2 focus:ring-primary focus:border-transparent' 
                    : 'border-light bg-gray-50'
                }`}
              />
            </div>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-neutral mb-1">
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              readOnly={!isEditing}
              className={`w-full p-2 border rounded-lg ${
                isEditing 
                  ? 'border-primary focus:ring-2 focus:ring-primary focus:border-transparent' 
                  : 'border-light bg-gray-50'
              }`}
            />
          </div>
          {isEditing && (
            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-primary hover:bg-primary-dark text-white px-4 py-2 rounded-lg transition-colors duration-200"
              >
                Save Changes
              </button>
            </div>
          )}
        </form>
      </div>

      {/* Password Update */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-primary">Password</h2>
          <button
            onClick={() => setShowPasswordForm(!showPasswordForm)}
            className="text-primary hover:text-primary-dark"
          >
            <i className={`fas ${showPasswordForm ? 'fa-times' : 'fa-key'}`}></i>
          </button>
        </div>

        {showPasswordForm ? (
          <form onSubmit={handlePasswordSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-neutral mb-1">
                  Current Password
                </label>
                <input
                  type="password"
                  name="currentPassword"
                  value={passwordData.currentPassword}
                  onChange={handlePasswordChange}
                  className="w-full p-2 border border-primary rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-neutral mb-1">
                  New Password
                </label>
                <input
                  type="password"
                  name="newPassword"
                  value={passwordData.newPassword}
                  onChange={handlePasswordChange}
                  className="w-full p-2 border border-primary rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-neutral mb-1">
                  Confirm New Password
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={passwordData.confirmPassword}
                  onChange={handlePasswordChange}
                  className="w-full p-2 border border-primary rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                  required
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="submit"
                  className="bg-primary hover:bg-primary-dark text-white px-4 py-2 rounded-lg transition-colors duration-200"
                >
                  Update Password
                </button>
              </div>
            </div>
          </form>
        ) : (
          <p className="text-neutral">Click the key icon to change your password.</p>
        )}
      </div>
    </div>
  );
};

export default Settings; 